module.exports = __webpack_public_path__ + "assets/img/74496c8ab438de2a46a944a597452e31.png";